<div class="select is-rounded">
  <select [(ngModel)]="SelectedState" (ngModelChange)="Apply()">
    <option value="all">All</option>
    <option value="missing">Missing</option>
    <option value="pending">Pending</option>
    <option value="collected">Collected</option>
  </select>
</div>

